import {
  GET_BLOGS, GET_BLOGS_FAIL, GET_BLOGS_SUCCESS,
  GET_BLOGS_BY_SLUG,GET_BLOGS_BY_SLUG_FAIL,GET_BLOGS_BY_SLUG_SUCCESS


} from "./actionTypes"

const INIT_STATE = {
  blogs: [],
  totalBlogs: 0,
  error: "",
  keys_error: "",
  loading: false,

  blogDetails: {},

}

const Blogs = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_BLOGS:
      return {
        ...state,
        loading: true,
      }

    case GET_BLOGS_SUCCESS:
      return {
        ...state,
        blogs: action.payload.data || [],
        totalBlogs: action.payload.total || 0,
        loading: false,
      }

    case GET_BLOGS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
      case GET_BLOGS_BY_SLUG:
        return {
          ...state,
          loading: true,
        }
  
      case GET_BLOGS_BY_SLUG_SUCCESS:
        return {
          ...state,
          blogDetails: action.payload.data ,
          loading: false,
        }
  
      case GET_BLOGS_BY_SLUG_FAIL:
        return {
          ...state,
          error: action.payload,
          loading: false,
        }

    default:
      return state
  }
}

export default Blogs
